import { useTransactionHistoryQuery } from '@order/graphql';

// ─────────────────────────────────────────────────────────────────────────────

export const useTransactionHistory = () => {
  const [{ data, fetching: isFetching }] = useTransactionHistoryQuery({
    requestPolicy: 'cache-and-network',
  });

  const transactionHistory =
    data?.paymentSubscriptionProfile?.transactionHistory;
  const hasTransactionHistory = !isFetching && transactionHistory !== undefined;

  return { isFetching, transactionHistory, hasTransactionHistory };
};
